<template>
  <div class="lds-ring">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</template>

<style scoped>
.lds-ring {
  display: inline-block;
  position: relative;
  width: 120px;
  height: 120px;
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 96px;
  height: 96px;
  margin: 8px;
  border: 10px solid #FFE94F;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #FFE94F transparent transparent transparent;
}

.whiteRing {
  width: 18px!important;
  height: 18px!important;
}

.whiteRing div {
  width: 18px!important;
  height: 18px!important;
  margin: 3px!important;
  border: 2px solid white!important;
  border-color: white transparent transparent transparent!important;
}

.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}

.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}

.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>
